import type { JWTPayload } from "jose";
import { jwtVerify, SignJWT } from "jose";

const JWT_SECRET = import.meta.env.VITE_JWT_SECRET!;
const ENCODED_SECRET = new TextEncoder().encode(JWT_SECRET);

const signPayload = async (payload: object, expirationTime: string = "1h"): Promise<string> => {
  const token = await new SignJWT(payload as JWTPayload)
    .setProtectedHeader({ alg: "HS256" })
    .setIssuedAt()
    .setExpirationTime(expirationTime)
    .sign(ENCODED_SECRET);

  return token;
};

const isTokenExpired = async (token: string): Promise<boolean> => {
  try {
    const { payload } = await jwtVerify(token, ENCODED_SECRET);

    if (payload.exp === undefined) {
      return true;
    }

    const currentTime = Math.floor(Date.now() / 1000);
    return payload.exp <= currentTime;
  } catch {
    return true;
  }
};

export { signPayload, isTokenExpired };
